const newrelic = typeof window !== 'undefined' ? window.newrelic : await import('newrelic');

export default function onNewRelicAlert(error, customAttributes) {
    newrelic.noticeError(error, customAttributes);
}
